import React from 'react'
import {useHistory} from 'react-router-dom'
import { useFormikContext } from 'formik'
import {useTranslation} from "react-i18next"
import store from "@formApp/store"

export default React.memo(({item, step}) => {
  const { values } = useFormikContext();
  const {t} = useTranslation();
  let history = useHistory();
  const {domainsList, transitions, formValues} = React.useContext(store);
  const handleChange = () => {
    formValues.set(values);
    history.push('step-1');
  };
  const handleClick = () => {
    if (step === 1 && (item.isAvailable || item.transfer)) {
      domainsList.setSelected(item);
      transitions.setCurrent('domainSelected');

      if (item.domain === '.it') {
        history.push('/step-2-it');
        formValues.setValue('siteName', item.name);

        dataLayer.push({
          event: 'track_funnel',
          eventCategory: 'Paid domain',
          eventAction: 'Prosegui',
          eventLabel: 'step-2-it',
        });
      } else if (item.domain === domainsList.groupDomain) {
        history.push('/step-2-altervista');
        formValues.setValue('userName', item.name);

        dataLayer.push({
          event: 'track_funnel',
          eventCategory: 'Free domain',
          eventAction: 'Prosegui',
          eventLabel: 'step-2-altervista',
        });
      } else {
        history.push('/step-2-other');
        formValues.setValue('siteName', item.name);

        dataLayer.push({
          event: 'track_funnel',
          eventCategory: 'Paid domain',
          eventAction: 'Prosegui',
          eventLabel: 'step-2-other',
        });
      }
    }
  };
  return (
    item &&
    <div onClick={handleClick} className={
      `domainsList--item
      ${item.isAvailable || item.transfer ? '' : ' --disabled'}
      ${(item.domain === domainsList.requestedTld) ? ' --accent' : ''}
      ${(item.domain === domainsList.groupDomain) ? ' --altervista' : ''}`
    }>
      <div className="siteName">
        <span>
        {
          `${(item.domain !== domainsList.groupDomain)
            ? 'www.'
            : (domainsList.groupDomain !== '.altervista.org')
              ? `${domainsList.groupDomain}` 
              : ''
          }${item.name}`
        }
        </span>
        <strong>{
          `${(domainsList.groupDomain === '.altervista.org')
            ? `${item.domain}`
            : ''
          }`
        }</strong>
      </div>
      <div className="siteInfo">
        <div className="sitePrice">
          {(!item.isAvailable && !item.transfer)
            ? <div>Non Disponibile</div>
            : <>
              {(item.transfer) && <span className="textForDomain">{t('etuo')} </span> }
              <span style={{textDecoration: 'line-through'}}>{(item.price) ? item.price : ''} </span>
              <strong className='finalPrice' data-message={t('gratis per sempre')}>{item.finalPrice} &euro;</strong>
              {(item.finalPrice) ? t(' + iva / mese') : ''}
            </>
          }
        </div>
        {(step === 1)
          ? <button type='button' disabled={!item.isAvailable && !item.transfer} className="btn-siteAction">
          {(item.domain === domainsList.groupDomain)
              ? <div>{t('Prosegui')} <span className="altervista-icon angle-circle-right"></span></div>
              : (item.transfer) 
                ? <div>{t('Trasferisci')} <svg xmlns="http://www.w3.org/2000/svg" width="13" height="11" viewBox="0 0 13 11"><g><g><path d="M9.847 10.242c0 .282.15.542.392.683.242.14.54.14.783 0a.789.789 0 0 0-.392-1.47.785.785 0 0 0-.783.787zm-6.699.683c.242.14.54.14.783 0a.789.789 0 0 0-.392-1.47.789.789 0 1 0-.391 1.47zm9.063-9.35H2.756c-.061 0-.115.022-.172.035L2.278.304A.394.394 0 0 0 1.895 0H.764a.394.394 0 0 0 0 .788h.819l.489 2.092.684 3.423c0 .028.014.053.017.08l-.401 1.805a.393.393 0 0 0 .384.479h8.938a.394.394 0 0 0 0-.788H3.248l.18-.812c.04.007.075.024.116.024h7.182c.435 0 .697-.086.907-.591l1.28-3.925c.221-.704-.266-1-.702-1z"/></g></g></svg></div>
                : <div>{t('Acquista')} <svg xmlns="http://www.w3.org/2000/svg" width="13" height="11" viewBox="0 0 13 11"><g><g><path d="M9.847 10.242c0 .282.15.542.392.683.242.14.54.14.783 0a.789.789 0 0 0-.392-1.47.785.785 0 0 0-.783.787zm-6.699.683c.242.14.54.14.783 0a.789.789 0 0 0-.392-1.47.789.789 0 1 0-.391 1.47zm9.063-9.35H2.756c-.061 0-.115.022-.172.035L2.278.304A.394.394 0 0 0 1.895 0H.764a.394.394 0 0 0 0 .788h.819l.489 2.092.684 3.423c0 .028.014.053.017.08l-.401 1.805a.393.393 0 0 0 .384.479h8.938a.394.394 0 0 0 0-.788H3.248l.18-.812c.04.007.075.024.116.024h7.182c.435 0 .697-.086.907-.591l1.28-3.925c.221-.704-.266-1-.702-1z"/></g></g></svg></div>
            }
          </button>
          : <button type='button' className="btn-siteAction" onClick={handleChange}>
            <div>{t('Cambia')} <span className="altervista-icon angle-circle-right"></span></div>
          </button>
        }
      </div>
    </div>
  )
})